// Import model
import { StartLeadCreateTaskRequest } from '../models/StartLeadCreateTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadCreateTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadCreateTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadCreateTaskRequest instance
   */
  static deserialize(json: string): StartLeadCreateTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadCreateTaskRequest instance
   */
  static fromObject(obj: any): StartLeadCreateTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadCreateTaskRequest');
    }


    const instance: StartLeadCreateTaskRequest = {
      description: obj['Description'] as string | undefined,
      dueDate: obj['DueDate'] as string | undefined,
      entityId: obj['EntityId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadCreateTaskRequest instances
   */
  static deserializeArray(json: string): StartLeadCreateTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadCreateTaskRequest instance to a JSON string
   */
  static serialize(instance: StartLeadCreateTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadCreateTaskRequest instance to a plain object
   */
  static toObject(instance: StartLeadCreateTaskRequest): any {
    return {
      'Description': instance.description,
      'DueDate': instance.dueDate,
      'EntityId': instance.entityId,
    };
  }

  /**
   * Serializes an array of StartLeadCreateTaskRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadCreateTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
